import { render, staticRenderFns } from "./CaCenterLayout.vue?vue&type=template&id=0b30d50b&"
import script from "./CaCenterLayout.vue?vue&type=script&lang=js&"
export * from "./CaCenterLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports